export default "__VITE_ASSET__Ehyf9wPZ__"